import { api } from '../lib/api.js';

export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  /** The catalogue entry to render in the reader's language (`lib/notificationText.ts`). */
  messageKey?: string | null;
  messageParams?: Record<string, string | number> | null;
  link: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  list: (unreadOnly = false) =>
    api
      .get<{ data: Notification[] }>('/notifications', {
        params: unreadOnly ? { unread: 'true' } : undefined,
      })
      .then((r) => r.data),
  unreadCount: () =>
    api.get<{ data: { count: number } }>('/notifications/unread-count').then((r) => r.data.count),
  markRead: (id: string) =>
    api.patch<{ data: { ok: true } }>(`/notifications/${id}/read`),
  /** How many the server marked — the count the confirmation says (§3.12), never assumed. */
  markAllRead: () =>
    api.patch<{ data: { count: number } }>('/notifications/read-all').then((r) => r.data.count),

  /**
   * WHAT THIS READER HAS CHOSEN TO HEAR ABOUT — every type, defaults filled in.
   *
   * Always the full list: the screen is a row of switches and a switch with no
   * state is not one. A type nobody has touched comes back `true/true`, so a
   * type added next release is on for everyone rather than off for everyone who
   * predates it.
   */
  preferences: () =>
    api
      .get<{ data: NotificationPreference[] }>('/notifications/preferences')
      .then((r) => r.data),

  /** Set one type's switches. Always the caller's own — the server resolves the
   *  employee from the token and accepts no id, so no shape of this request
   *  edits somebody else's inbox. */
  setPreference: (type: string, patch: { inApp?: boolean; email?: boolean }) =>
    api
      .put<{ data: NotificationPreference }>(`/notifications/preferences/${type}`, patch)
      .then((r) => r.data),
};

/** One type's switches for this reader. */
export interface NotificationPreference {
  type: string;
  /** Show it in the bell and on this page. */
  inApp: boolean;
  /** Also email it. ANDed with the company-wide email switch — a person may
   *  turn their own off, never turn it on when the company has it off. */
  email: boolean;
}
